import React from 'react';
import hydrogen from './images/hydrogen.jpg';
import '../style.css';

const Hydrogen = () => {
    return (
        <>
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundImage: `url('${hydrogen}')`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', minHeight: '250px' }}>
                <h1 style={{ textShadow: '1px 1px 4px rgba(0,0,0,0.8)' }}>Our Hydrogen Hybrid Technology</h1>
            </div>
            <div className='blog'>
                <div className='blog-project1'>
                    <p>
                        OctoNexus Power's hydrogen hybrid technology integrates green hydrogen production with advanced energy storage and conversion systems. Our electrolysis-based approach uses renewable energy sources to split water into hydrogen and oxygen, producing clean fuel with zero carbon emissions.
                    </p>
                    <p>
                        Our hydrogen systems are designed for modularity and scalability — from small off-grid deployments to large industrial installations. Compressed hydrogen is stored in purpose-built modular tanks, ready to be converted back into electricity on demand via fuel cells.
                    </p>
                    <p>
                        At the heart of our technology is AI-optimised control — continuously balancing hydrogen production, storage, and discharge to maximise efficiency and minimise waste. This makes our systems ideal for remote locations, emergency power, and zero-emission transport infrastructure.
                    </p>
                    <p>
                        Interested in deploying hydrogen hybrid technology at your site? <a href="/contactus" style={{ color: '#0fa19a' }}>Contact us</a> to discuss your energy needs.
                    </p>
                </div>
                <div className='blog-project2'>
                    <h2>Key Advantages</h2>
                    <ul>
                        <li>Zero-emission hydrogen production from renewables</li>
                        <li>Long-duration energy storage capability</li>
                        <li>Modular and scalable system architecture</li>
                        <li>AI-optimised performance and predictive maintenance</li>
                        <li>Compatible with existing renewable energy assets</li>
                    </ul>
                </div>
            </div>
        </>
    );
};
export default Hydrogen;
